module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    attrs: {
      "id": "sessao_tipo_do_seguro"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "renovacao"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_c('icon', {
    attrs: {
      "name": "repeat"
    }
  }), _vm._v(" Tipo do seguro\n                    "), _c('form-help', {
    attrs: {
      "title": "Tipo do seguro",
      "description": "Se for o primeiro seguro selecione a opção Novo Negócio, caso contrário selecione a companhia do seu seguro vigente."
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('renewalInsurers.name')
    }
  }, [_c('label', {
    attrs: {
      "for": _vm.renewalInsurers.id
    }
  }, [_vm._v(_vm._s(_vm.renewalInsurers.label))]), _vm._v(" "), _c('v-select', {
    staticClass: "auto-select",
    attrs: {
      "options": _vm.renewalInsurers.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": _vm.renewalInsurers.name,
      "id": _vm.renewalInsurers.id,
      "placeholder": _vm.renewalInsurers.placeholder
    },
    model: {
      value: (_vm.renewal.insurer),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "insurer", $$v)
      },
      expression: "renewal.insurer"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has(_vm.renewalInsurers.name)) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.renewalInsurers.name)))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    ref: "hasRenovation"
  }, [_c('div', {
    staticClass: "row renovacao"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.renewal.bonus_last')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.renewal.bonus_last"
    }
  }, [_vm._v("Classe de bônus Anterior")]), _vm._v(" "), _c('form-help', {
    attrs: {
      "title": "Classe de bônus anterior",
      "description": "Deve-se informar a classe de bônus do contrato anterior.<br>Seguradoras que utilizam esse campo:<li>SulAmerica</li><li>Bradesco</li><li>Generali</li>"
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.renewal.bonus_last),
      expression: "renewal.bonus_last"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: (_vm.renewal.insurer != 'new')
        }
      }),
      expression: "{ rules: { required: (renewal.insurer != 'new') } }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "data.renewal.bonus_last",
      "name": "data.renewal.bonus_last",
      "data-vv-as": "Bônus Anterior"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.renewal, "bonus_last", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" - Selecione - ")]), _vm._v(" "), _vm._l((_vm.currentBonusClassOptions), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item) + "\n                            ")])
  })], 2), _vm._v(" "), (_vm.errors.has('data.renewal.bonus_last')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.renewal.bonus_last')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.renewal.bonus_current')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.renewal.bonus_current"
    }
  }, [_vm._v("Classe de bônus Futura")]), _vm._v(" "), _c('form-help', {
    attrs: {
      "title": "Classe de bônus a ser calculada",
      "description": "Deve-se informar a classe de bônus que será calculada na nova vigência. Por exemplo: Se a classe de bônus vigente é 2, então você irá informar neste campo o valor 3."
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.renewal.bonus_current),
      expression: "renewal.bonus_current"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: (_vm.renewal.insurer != 'new')
        }
      }),
      expression: "{ rules: { required: (renewal.insurer != 'new') } }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "data.renewal.bonus_current",
      "name": "data.renewal.bonus_current",
      "data-vv-as": "Bônus Futuro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.renewal, "bonus_current", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" - Selecione - ")]), _vm._v(" "), _vm._l((_vm.currentBonusClassOptions), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item) + "\n                            ")])
  })], 2), _vm._v(" "), (_vm.errors.has('data.renewal.bonus_current')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.renewal.bonus_current')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.renewal.claim_amount')
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: (_vm.renewal.insurer != 'new'),
          numeric: true
        }
      }),
      expression: "{ rules: { required: (renewal.insurer != 'new'), numeric: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.renewal.claim_amount),
      expression: "renewal.claim_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "data.renewal.claim_amount",
      "name": "data.renewal.claim_amount",
      "min": "0",
      "data-vv-as": "Quantidade de Sinistros"
    },
    domProps: {
      "value": (_vm.renewal.claim_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.renewal, "claim_amount", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.renewal.claim_amount')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.renewal.claim_amount')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.renewal.prior_policy_end')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.renewal.prior_policy_end"
    }
  }, [_vm._v("Data Final da Apólice Vigente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.renewal.prior_policy_end),
      expression: "renewal.prior_policy_end"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "data.renewal.prior_policy_end",
      "name": "data.renewal.final_apolice",
      "data-vv-as": "Data Final da Apólice Vigente"
    },
    domProps: {
      "value": (_vm.renewal.prior_policy_end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.renewal, "prior_policy_end", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.renewal.prior_policy_end')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.renewal.prior_policy_end')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.renewal.prior_policy')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.renewal.prior_policy"
    }
  }, [_vm._v("Número da Apólice Vigente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.renewal.prior_policy),
      expression: "renewal.prior_policy"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "data.renewal.prior_policy",
      "name": "data.renewal.prior_policy"
    },
    domProps: {
      "value": (_vm.renewal.prior_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.renewal, "prior_policy", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.renewal.prior_policy')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.renewal.prior_policy')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.renewal.prior_ic')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.renewal.prior_ic"
    }
  }, [_vm._v("C.I Vigente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.renewal.prior_ic),
      expression: "renewal.prior_ic"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "data.renewal.prior_ic",
      "name": "data.renewal.prior_ic"
    },
    domProps: {
      "value": (_vm.renewal.prior_ic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.renewal, "prior_ic", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.renewal.prior_ic')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.renewal.prior_ic')))]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "lb-rd-esq",
    attrs: {
      "for": "data.renewal.claim_amount"
    }
  }, [_vm._v("Quantidade de Sinistros "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17388ebe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/modules/RenovationNew/FormPartialRenovation.vue
// module id = 333
// module chunks = 0